
// import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
// import api from '../services/api';

// interface User {
//   id: string;
//   name: string;
//   email: string;
//   company: string;
//   tenant_id?: string;
//   role?: string;
//   require_password_reset?: boolean;
// }

// interface TenantPlan {
//   plan: string;
//   plan_status: string;
//   max_vendors: number;
//   max_users: number;
//   max_indicators: number;
//   trial_end_date: string;
//   trial_days_remaining: number;
// }

// interface Tenant {
//   id: string;
//   company_name: string;
//   subdomain: string;
//   plan?: TenantPlan;
// }

// interface AuthContextType {
//   user: User | null;
//   tenant: Tenant | null;
//   token: string | null;
//   isLoading: boolean;
//   login: (email: string, password: string) => Promise<User>;
//   signup: (name: string, email: string, password: string, company: string, companyDomain?: string) => Promise<void>;
//   logout: () => void;
//   isAuthenticated: boolean;
//   refreshTenant: () => Promise<Tenant | null>;
// }

// const AuthContext = createContext<AuthContextType | undefined>(undefined);

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// interface AuthProviderProps {
//   children: ReactNode;
// }

// export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
//   const [user, setUser] = useState<User | null>(null);
//   const [tenant, setTenant] = useState<Tenant | null>(null);
//   const [token, setToken] = useState<string | null>(null);
//   const [isLoading, setIsLoading] = useState(true);

//   // ─── LOAD FROM LOCALSTORAGE ON MOUNT ──────────────────────────────────────
//   useEffect(() => {
//     const savedToken = localStorage.getItem('access_token');
//     const savedUser = localStorage.getItem('user');
//     const savedTenant = localStorage.getItem('tenant');
    
//     if (savedToken) {
//       setToken(savedToken);
//     }
//     if (savedUser) {
//       setUser(JSON.parse(savedUser));
//     }
//     if (savedTenant) {
//       setTenant(JSON.parse(savedTenant));
//     }
//     setIsLoading(false);
//   }, []);

//   // ─── REFRESH TENANT FROM API ──────────────────────────────────────────────
//   const refreshTenant = async (): Promise<Tenant | null> => {
//     try {
//       const token = localStorage.getItem('access_token');
//       if (!token) return null;
      
//       const response = await api.get('/v1/auth/me');
//       const data = response.data;
      
//       console.log('🔄 Refreshed Tenant Data:', data);
//       console.log('🔄 Tenant Plan:', data?.tenant?.plan);
      
//       // Update user state
//       if (data?.user) {
//         setUser(data.user);
//         localStorage.setItem('user', JSON.stringify(data.user));
//       }
      
//       // Update tenant state with plan
//       if (data?.tenant) {
//         // Make sure plan is included
//         const tenantData = {
//           ...data.tenant,
//           plan: data.tenant.plan || null
//         };
//         setTenant(tenantData);
//         localStorage.setItem('tenant', JSON.stringify(tenantData));
//         console.log('✅ Tenant updated:', tenantData);
//         return tenantData;
//       }
      
//       return null;
//     } catch (error) {
//       console.error('❌ Failed to refresh tenant:', error);
//       return null;
//     }
//   };

//   // ─── LOGIN ──────────────────────────────────────────────────────────────────
//   const login = async (email: string, password: string): Promise<User> => {
//     try {
//       const response = await api.post('/v1/auth/login', {
//         email,
//         password,
//       });
      
//       const { access_token, user, tenant } = response.data;
      
//       console.log('🔍 Login Response:', { access_token, user, tenant });
//       console.log('🔍 Tenant Plan:', tenant?.plan);
      
//       setToken(access_token);
//       setUser(user);
//       setTenant(tenant || null);
      
//       localStorage.setItem('access_token', access_token);
//       localStorage.setItem('user', JSON.stringify(user));
//       if (tenant) {
//         localStorage.setItem('tenant', JSON.stringify(tenant));
//       }
      
//       return user;
      
//     } catch (error: any) {
//       console.error('❌ Login error:', error.response?.data);
//       throw new Error(error.response?.data?.detail || 'Login failed');
//     }
//   };

//   // ─── SIGNUP ─────────────────────────────────────────────────────────────────
//   const signup = async (name: string, email: string, password: string, company: string) => {
//     try {
//       const response = await api.post('/v1/auth/signup', {
//         name,
//         email,
//         password,
//         company,
//       });
      
//       const { access_token, user, tenant } = response.data;
      
//       setToken(access_token);
//       setUser(user);
//       setTenant(tenant || null);
      
//       localStorage.setItem('access_token', access_token);
//       localStorage.setItem('user', JSON.stringify(user));
//       if (tenant) {
//         localStorage.setItem('tenant', JSON.stringify(tenant));
//       }
      
//     } catch (error: any) {
//       throw new Error(error.response?.data?.detail || 'Signup failed');
//     }
//   };

//   // ─── LOGOUT ─────────────────────────────────────────────────────────────────
//   const logout = () => {
//     setToken(null);
//     setUser(null);
//     setTenant(null);
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('user');
//     localStorage.removeItem('tenant');
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         tenant,
//         token,
//         isLoading,
//         login,
//         signup,
//         logout,
//         isAuthenticated: !!user && !!token,
//         refreshTenant,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import api from '../services/api';
import { queryClient } from '../lib/queryClient';
import { IDLE_REASON, clearActivity, isIdleExpired, markActivity } from '../lib/idleSession';

interface User {
  id: string;
  name: string;
  email: string;
  company: string;
  tenant_id?: string;
  role?: string;
  require_password_reset?: boolean;
  job_title?: string;                 // 👈 ADDED
  department?: string;                // 👈 ADDED
  phone_number?: string;              // 👈 ADDED
  location?: string;                  // 👈 ADDED
  password_changed_at?: string;       // 👈 ADDED
  session_timeout_hours?: number;     // 👈 ADDED
}

interface TenantPlan {
  plan: string;
  plan_status: string;
  max_vendors: number;
  max_users: number;
  max_indicators: number;
  trial_end_date: string;
  trial_days_remaining: number;
  // Exact counts from the server: max_indicators is only a limit switch, the real total grows as checks are added.
  indicators_included?: number;
  indicators_total?: number;
  all_indicators?: boolean;
  // Plan name (Tropos / Strato / Meso / Thermo / Exo / Custom) and any extra vendors/users granted on top of it.
  plan_name?: string;
  extra_vendors?: number;
  extra_users?: number;
}

interface Tenant {
  id: string;
  company_name: string;
  subdomain: string;
  plan?: TenantPlan;
}

interface AuthContextType {
  user: User | null;
  tenant: Tenant | null;
  token: string | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<User>;
  signup: (name: string, email: string, password: string, company: string, companyDomain: string | undefined, portalClaim: string | undefined, agreeToTerms: boolean, marketingConsent: boolean, companySize: string, vendorsManaged: string) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  refreshTenant: () => Promise<Tenant | null>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // ─── LOAD FROM LOCALSTORAGE ON MOUNT ──────────────────────────────────────
  useEffect(() => {
    const savedToken = localStorage.getItem('access_token');
    const savedUser = localStorage.getItem('user');
    const savedTenant = localStorage.getItem('tenant');

    // Reopened after longer than the auto sign-out period: drop the saved session instead of restoring it.
    if (savedToken && isIdleExpired(savedUser ? JSON.parse(savedUser)?.session_timeout_hours : null)) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      localStorage.removeItem('tenant');
      clearActivity();
      setIsLoading(false);
      window.location.replace(`/login?reason=${IDLE_REASON}`);
      return;
    }

    if (savedToken) {
      setToken(savedToken);
    }
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    if (savedTenant) {
      setTenant(JSON.parse(savedTenant));
    }
    setIsLoading(false);
  }, []);

  // ─── REFRESH TENANT FROM API ──────────────────────────────────────────────
  const refreshTenant = async (): Promise<Tenant | null> => {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) return null;
      
      const response = await api.get('/v1/auth/me');
      const data = response.data;
      
      console.log('🔄 Refreshed Tenant Data:', data);
      console.log('🔄 Tenant Plan:', data?.tenant?.plan);
      
      // Update user state
      if (data) {
        const userData: User = {
          id: data.id,
          name: data.name,
          email: data.email,
          company: data.company,
          tenant_id: data.tenant_id,
          role: data.role,
          require_password_reset: data.require_password_reset,
          job_title: data.job_title,
          department: data.department,
          phone_number: data.phone_number,
          location: data.location,
          password_changed_at: data.password_changed_at,        // 👈 ADDED
          session_timeout_hours: data.session_timeout_hours,    // 👈 ADDED
        };
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
      }
      
      // Update tenant state with plan
      if (data?.tenant) {
        const tenantData = {
          ...data.tenant,
          plan: data.tenant.plan || null
        };
        setTenant(tenantData);
        localStorage.setItem('tenant', JSON.stringify(tenantData));
        console.log('✅ Tenant updated:', tenantData);
        return tenantData;
      }
      
      return null;
    } catch (error) {
      console.error('❌ Failed to refresh tenant:', error);
      return null;
    }
  };

  // ─── LOGIN ──────────────────────────────────────────────────────────────────
  const login = async (email: string, password: string): Promise<User> => {
    try {
      const response = await api.post('/v1/auth/login', {
        email,
        password,
      });
      
      const { access_token, user, tenant } = response.data;
      
      console.log('🔍 Login Response:', { access_token, user, tenant });
      console.log('🔍 Tenant Plan:', tenant?.plan);
      
      // Create full user object with all fields
      const userData: User = {
        id: user.id,
        name: user.name,
        email: user.email,
        company: user.company,
        tenant_id: user.tenant_id,
        role: user.role,
        require_password_reset: user.require_password_reset,
        job_title: user.job_title,
        department: user.department,
        phone_number: user.phone_number,
        location: user.location,
        password_changed_at: user.password_changed_at,        // 👈 ADDED
        session_timeout_hours: user.session_timeout_hours,    // 👈 ADDED
      };
      
      setToken(access_token);
      setUser(userData);
      setTenant(tenant || null);
      
      localStorage.setItem('access_token', access_token);
      markActivity();
      localStorage.setItem('user', JSON.stringify(userData));
      if (tenant) {
        localStorage.setItem('tenant', JSON.stringify(tenant));
      }
      
      return userData;
      
    } catch (error: any) {
      console.error('❌ Login error:', error.response?.data);
      throw new Error(error.response?.data?.detail || 'Login failed');
    }
  };

  // ─── SIGNUP ─────────────────────────────────────────────────────────────────
  const signup = async (name: string, email: string, password: string, company: string, companyDomain: string | undefined, portalClaim: string | undefined, agreeToTerms: boolean, marketingConsent: boolean, companySize: string, vendorsManaged: string) => {
    try {
      const response = await api.post('/v1/auth/signup', {
        name,
        email,
        password,
        company,
        agree_to_terms: agreeToTerms,
        marketing_consent: marketingConsent,
        company_size: companySize,
        vendors_managed: vendorsManaged,
        ...(companyDomain ? { company_domain: companyDomain } : {}),
        // The vendor portal's signed "Get your full report" hand-off (only honoured for the same email).
        ...(portalClaim ? { portal_claim: portalClaim } : {}),
      });
      
      const { access_token, user, tenant } = response.data;
      
      // Create full user object with all fields
      const userData: User = {
        id: user.id,
        name: user.name,
        email: user.email,
        company: user.company,
        tenant_id: user.tenant_id,
        role: user.role,
        require_password_reset: user.require_password_reset,
        job_title: user.job_title,
        department: user.department,
        phone_number: user.phone_number,
        location: user.location,
        password_changed_at: user.password_changed_at,        // 👈 ADDED
        session_timeout_hours: user.session_timeout_hours,    // 👈 ADDED
      };
      
      setToken(access_token);
      setUser(userData);
      setTenant(tenant || null);
      
      localStorage.setItem('access_token', access_token);
      markActivity();
      localStorage.setItem('user', JSON.stringify(userData));
      if (tenant) {
        localStorage.setItem('tenant', JSON.stringify(tenant));
      }
      
    } catch (error: any) {
      throw new Error(error.response?.data?.detail || 'Signup failed');
    }
  };

  // ─── LOGOUT ─────────────────────────────────────────────────────────────────
  const logout = () => {
    setToken(null);
    setUser(null);
    setTenant(null);
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('tenant');
    clearActivity();
    // Cached server data belongs to this user's tenant; never let it show to whoever signs in next.
    queryClient.clear();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        tenant,
        token,
        isLoading,
        login,
        signup,
        logout,
        isAuthenticated: !!user && !!token,
        refreshTenant,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};